import React from 'react'
import { Line } from 'react-chartjs-2'
import styled from 'styled-components'
import { Button } from 'reactstrap'
import get from 'lodash/get'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'
import { FONTS } from '../../constants'

class ActiveUsersChart extends React.Component {
  render() {
    Chart.defaults.scale.ticks.beginAtZero = true
    const data = {
      labels: get(this.props, 'active_users.key'),
      datasets: [
        {
          label: 'Number of Users',
          datalabels: {
            anchor: 'start',
            align: 'end',
            backgroundColor: null,
            borderColor: null,
            borderRadius: 4,
            borderWidth: 1,
            color: '#000000',
            font: {
              size: 11,
              weight: 600,
            },
            offset: 15,
            padding: 0,
          },
          fill: false,
          lineTension: 0.1,
          cubicInterpolationMode: 'monotone',
          backgroundColor: '#AD2624',
          borderColor: '#AD2624',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#AD2624',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#AD2624',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 5,
          pointHitRadius: 10,
          data: get(this.props, 'active_users.value'),
        },
      ],
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
            },
          }],
        },
        plugins: {
        },
      },
    }
    return (
      <ChartContainer>
        <div style={ { display: 'flex' } }>
          <LabelChart>Daily Active Users</LabelChart>
          <DivNavCalendar>
            <ArrowButton onClick={ this.props.left }>&#65308;</ArrowButton>
            <LabelChart>
              { this.props.moment.format('MMMM')} {this.props.moment.format('YYYY') }
            </LabelChart>
            <ArrowButton onClick={ this.props.right }>&#65310;</ArrowButton>
          </DivNavCalendar>
        </div>
        <Line data={ data } height='70%' />
      </ChartContainer>
    )
  }
}

export default ActiveUsersChart

const ChartContainer = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  max-width: 100%;
  margin-bottom: 2%;
  background-color: #FFFFFF;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const LabelChart = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
  margin-top: 2%;
  margin-left: 2%;
`
const ArrowButton = styled(Button)`
  height: 35px;
  margin-left: 2%;
  background-color: #ffffff;
  color: #333333;
`
const DivNavCalendar = styled.div`
  margin-top: 2%;
  margin-right: 5%;
  display: 'flex';
  flex-direction: row;
  flex: 1;
  text-align: right;
`



// WEBPACK FOOTER //
// ./src/components/report-active-users-chart/index.js